import CallCenterProvider from "@/context/call.center.context";
import Loader from "@/components/Loader";
import RoleGuard from "@/guards/RoleGuard";
import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import DashboardLayout from "../layouts/dashboard";
import {
  PATH_CALL_CENTER,
  PATH_CALL_CENTER_CALL_LEAD,
  PATH_CALL_CENTER_CLOUD_RECORDINGS,
  PATH_CALL_CENTER_CLOUD_RECORDING_DETAILS,
  PATH_CALL_CENTER_JOIN,
  PATH_CALL_CENTER_JOIN_AS_ADMIN,
  PATH_CALL_CENTER_LEAD_RATE,
  PATH_CALL_CENTER_EOD_REPORT,
  PATH_CALL_CENTER_COMPANY_ROOM,
  PATH_CALL_CENTER_PERSONAL_ROOM_RECORDINGS,
} from "./paths";
import { getRelativePath } from "@/utils/paths";

const CallCenterContainer = lazy(() => import("../pages/call-center/call.center.container"));
const JoinMeetingAsAgent = lazy(() => import("../pages/call-center/join-meeting/index"));
const JoinMeetingAsAdmin = lazy(() => import("../pages/call-center/join-meeting-as-admin/index"));
const CallLeadAsAgentContainer = lazy(() => import("../pages/call-center/call-lead/call.lead.as.agent.container"));
const EodReportContainer = lazy(() => import("../pages/call-center/eod-report/eod-report.container"));
const RateLeadContainer = lazy(() => import("../pages/call-center/lead.rating.container"));
const CloudRecordingsContainer = lazy(() => import("../pages/call-center/cloud-recordings/cloud-recordings.container"));
const PersonalRoomRecordingsContainer = lazy(() => import("../pages/call-center/cloud-recordings/personal-room-recordings.container"));
const RecordingDetailsContainer = lazy(() => import("../pages/call-center/cloud-recordings/recording-details/recording-details.container"));
const CompanyRoom = lazy(() => import("../pages/call-center/company-room/index"));

const CallCenterRoot = () => (
  <AuthGuard>
    <RoleGuard>
      <CallCenterProvider>
        <DashboardLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </CallCenterProvider>
    </RoleGuard>
  </AuthGuard>
);

const callCenterRoutes = [
  {
    path: PATH_CALL_CENTER,
    element: <CallCenterRoot />,
    children: [
      {
        index: true,
        element: <CallCenterContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_JOIN),
        element: <JoinMeetingAsAgent />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_JOIN_AS_ADMIN),
        element: <JoinMeetingAsAdmin />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_CALL_LEAD),
        element: <CallLeadAsAgentContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_EOD_REPORT),
        element: <EodReportContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_LEAD_RATE),
        element: <RateLeadContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_CLOUD_RECORDINGS),
        element: <CloudRecordingsContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_CLOUD_RECORDING_DETAILS),
        element: <RecordingDetailsContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_PERSONAL_ROOM_RECORDINGS),
        element: <PersonalRoomRecordingsContainer />,
      },
      {
        path: getRelativePath(PATH_CALL_CENTER, PATH_CALL_CENTER_COMPANY_ROOM),
        element: <CompanyRoom />,
      },
    ],
  },
];

export default callCenterRoutes;
